import {Link} from 'react-router'

import {getCrossProductLinks} from '@core/products/cross-links'
import {Oculus} from '@product/ovid/components/Oculus/Oculus'

import styles from './VeiledFooter.module.scss'

const siblingHouses = getCrossProductLinks('ovid')

/**
 * VeiledFooter — the colophon for the new host (`thinking/plans/2026_09_17_ovid_veiled_wall.md`
 * step 2, this pass's own item): below the home's endpaper, anonymous-only (mounted from `VeiledWall`,
 * which itself only ever renders for an anonymous visitor).
 *
 * Deliberately NOT the existing `products/ovid/components/Footer/Footer.tsx` — that component
 * links `/packs` (no pack pages exist on the new host, plan step 8) and prints "ovidmuse.com"
 * (the new host is `ovid.gallery`; step 9's "no link, no redirect, no shared Organization entity"
 * ruling extends to the footer's own colophon line, not just the JSON-LD). A new, small component
 * rather than a prop to the old one — the two footers diverge on what they're allowed to link to,
 * not on styling. The sister houses are linked here as in every house footer (operator, 2026-10-10).
 *
 * Ovid House tokens (`--ov-*`, `styles/index.scss`) rather than the wall's own `--vw-*` set
 * (`VeiledWall.module.scss`) — those are scoped to `.wall` and describe a deliberately different,
 * darker palette for the grid itself; the footer sits beside the endpaper, which already reads
 * off the global `--ov-*` tokens, so this component matches that neighbour instead of the grid.
 */
export function VeiledFooter() {
    const year = new Date().getFullYear()

    return (
        <footer className={styles.footer}>
            <Link to="/" className={styles.brand} aria-label="Ovid — home">
                <Oculus size={22} />
                <span className={styles.wordmark}>Ovid</span>
            </Link>

            <nav className={styles.links} aria-label="Legal">
                <Link to="/terms">Terms</Link>
                <Link to="/privacy">Privacy</Link>
            </nav>

            <nav className={styles.links} aria-label="Sister houses">
                {siblingHouses.map((house) => (
                    <a key={house.id} href={house.url} target="_blank" rel="noopener">
                        {house.name}
                    </a>
                ))}
            </nav>

            <p className={styles.notice}>Adults only. Every picture is synthetic.</p>

            <span className={styles.year}>© {year} Ovid</span>
        </footer>
    )
}

export default VeiledFooter
